import { render, staticRenderFns } from "./LearningGroupTable.vue?vue&type=template&id=11a640ce&"
import script from "./LearningGroupTable.vue?vue&type=script&lang=ts&"
export * from "./LearningGroupTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports